// extracted by mini-css-extract-plugin
export default {"formBtns":"FormButtons_formBtns__15sJb","leftBtn":"FormButtons_leftBtn__7AcDO"};